import { Component, OnInit } from '@angular/core';
import { Artiste } from '../models/artiste.model';
import { ArtisteService } from '../services/artiste.service';

@Component({
  selector: 'app-artistes',
  templateUrl: './artistes.component.html',
  styleUrls: ['./artistes.component.css']
})
export class ArtistesComponent implements OnInit {

  artistes: Artiste[] = [];

  constructor(private artisteService: ArtisteService) { }

  ngOnInit(): void {
    this.artisteService.getArtistes().subscribe(data => {
      this.artistes = data;
    });
  }

  // Permet d'afficher un lecteur video au lieu d'une image si l'admin a importe
  // une video (MP4, WEBM, MOV, AVI) comme photo d'artiste
  estVideo(url: string | undefined | null): boolean {
    if (!url) return false;
    return /\.(mp4|webm|mov|avi)(\?.*)?$/i.test(url);
  }
}
